import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { IconSettingsSlidersOutline, IconSettingsSlidersSolid } from '@brandlive1941/pixel';
import { GreenroomState as GS } from '../../../stores/types/types';
import SelectSmall from '../../general-components/select-small';
import colors from '../../../utils/colors';
import { UpdateBroadcastResolution } from '../../../connection/broadcasting';
import { RESOLUTION_OPTIONS } from '../../../stores/types/broadcasting';

const ResolutionContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin: 24px 40px 0;
	height: 64px;
	padding: 0 24px 0 16px;
	background: var(--primitives-mode-1-gray-800);
	border-radius: 0.8571rem;
	flex: 0 0 auto;

	.resolution-dropdown {
		.select-label {
			width: 96px;
			border-radius: 7.142rem;
			border: 1px solid ${colors.blGrayscale400};;
			justify-content: space-between;
			width: 96px;
			padding: 8px 16px !important;
			font-size: 0.8571rem !important;
			font-weight: 500 !important;
			line-height: 1.143rem !important;
			letter-spacing: 0.24px;
			transition: border-color 250ms ease-in-out;

			&:hover {
				border: 1px solid ${colors.blGrayscale200};;
			}
		}

		.select-body {
			border-top: none;
			left: -2px;
			
			.select-option {
				padding: 8px 16px
			}
		}

		label {
			font-size: 0.8571rem;
			line-height: 1.143rem;
		}
	}
`;

interface Props {
	style?: CSSProperties;
}

export default function StreamingResolution({ style }: Props) {
	const token = useSelector((s: GS) => s.SessionReducer.token);
	const homeMeeting = useSelector((s: GS) => s.HomeReducer.homeMeeting);
	const meeting = useSelector((s: GS) => s.SessionReducer.meeting);
	const resolution = useSelector((s: GS) => s.BroadcastReducer.resolution);
	const usePixel = useSelector((s: GS) => s.SettingsReducer.featureFlags?.use_pixel);

	const handleChangeResolution = async (newResolution: string) => {
		const currentMeeting = meeting || homeMeeting;
		if (!token || !currentMeeting) return;
		await UpdateBroadcastResolution(token, currentMeeting.meeting, newResolution);
	};

	return (
		<ResolutionContainer style={style}>
			<div className="flex-align-center">
				<IconSettingsSlidersSolid size={usePixel ? 16 : 24} color={'var(--primitives-mode-1-gray-400)'} className='margin-right-small' />
				<span className="bl-font-s1 text-gray-200">Quality</span>
			</div>
			<SelectSmall
				options={RESOLUTION_OPTIONS}
				onChange={handleChangeResolution}
				label={resolution}
				selected={
					RESOLUTION_OPTIONS.find((option) => option.value === resolution)
					|| RESOLUTION_OPTIONS[0]
				}
				optionHeight={32}
				dropdown={true}
				className='resolution-dropdown bl-font-p2'
			/>
		</ResolutionContainer>
	);
}
